import axios from "../../axios";

const updateProxy = async function (accessToken, data = {}) {
    try {
        const response = await axios.post('proxy/updateProxy', data, {
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response?.status || 500,
            message: e.response?.data?.message || 'Có lỗi xảy ra'
        }
    }
}

export default updateProxy;

